export const BOOTSTRAP_MESSAGES = {
  PACKAGE_RUNTIME_CONFIG_FAILED: 'Failed to configure package runtime facade.',
  PACKAGE_RUNTIME_POST_BOOTSTRAP_FAILED: 'Failed to run package post-bootstrap task.',
  BOOTSTRAP_ADAPTER_RUNTIME_MISMATCH: 'Adapter does not support the active runtime.',
} as const;
